<template>
  <div class="p-12">
    <div class="max-w-lg mx-auto gutter">
      <BaseLayoutSpaced relaxed>
        <h4 class="text-primary capitalize">Νέο Πακέτο</h4>
        <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
          <form class="max-w-lg mx-auto" @submit.prevent="handleSubmit(createPackage)">
            <BaseLayoutSpaced relaxed>
              <ValidationProvider
                v-for="field in formFieldsWithDefaults"
                :key="field.name"
                :name="field.name"
                :vid="field.name"
                :rules="field.validation"
                v-slot="{ errors, failed }"
                slim
              >
                <BaseFormGroup>
                  <BaseFormLabel :for="`${_uid}-${field.name}`">
                    {{ field.label }} <template v-if="field.validation.required"> * </template>
                  </BaseFormLabel>
                  <Component
                    v-model="data[field.name]"
                    :is="field.component"
                    :disabled="submitting"
                    v-bind="{
                      ...field.options.props,
                      ...field.options.attrs,
                    }"
                    :invalid="failed"
                    :id="`${_uid}-${field.name}`"
                  />
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </ValidationProvider>

              <BaseFormInlineMessage v-if="message" danger>
                {{ message }}
              </BaseFormInlineMessage>

              <div class="text-right">
                <BaseButton primary type="submit" :disabled="invalid || submitting">
                  <span v-if="!submitting">Submit</span>
                  <Loader v-else small inverse />
                </BaseButton>
              </div>
            </BaseLayoutSpaced>
          </form>
        </ValidationObserver>
      </BaseLayoutSpaced>
    </div>
  </div>
</template>

<script>
import { storePackageApi } from '@/api/clients/admin';
import { PRODUCTS } from '@/store/entities/schema_types';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';

const defaultField = {
  component: null,
  label: '',
  name: '',
  options: {},
  validation: {},
};

export default {
  name: 'BasicProductCreateView',
  data: () => ({
    data: {
      name: '',
      description: null,
      price: null,
      requirements: null,
      producesModelType: null,
    },
    formFields: [
      {
        component: 'BaseFormInput',
        label: 'Name',
        name: 'name',
        options: {
          attrs: {
            type: 'text',
            name: 'name',
          },
        },
        validation: {
          required: true,
          min: 5,
          max: 255,
        },
      },
      {
        component: 'BaseFormTextarea',
        label: 'Description',
        name: 'description',
        options: {
          attrs: {
            name: 'description',
          },
        },
        validation: {
          max: 500,
        },
      },
      {
        component: 'BaseFormInput',
        label: 'Price',
        name: 'price',
        options: {
          attrs: {
            type: 'number',
            name: 'price',
            step: '0.01',
          },
        },
        validation: {
          required: true,
          decimal: 2,
          min_value: 1,
        },
      },
    ],
    submitting: false,
    message: null,
  }),
  computed: {
    formFieldsWithDefaults() {
      return this.formFields.map((x) => ({ ...defaultField, ...x }));
    },
  },
  methods: {
    async createPackage() {
      try {
        this.submitting = true;

        const response = await storePackageApi(this.data);

        const { data } = response.data;

        const packageId = await this.$store.dispatch('entities/persistEntities', {
          type: PRODUCTS,
          data,
        });

        this.goToPackage(packageId);
      } catch (error) {
        if (!error.response) return;

        const { status, data } = error.response;

        const { message = null } = data;

        this.message = message;

        if (status === HTTP_UNPROCESSABLE_ENTITY) this.submitting = false;
      }
    },
    goToPackage(packageId) {
      this.$router.replace({
        name: 'admin.products.packages.package',
        params: { ...this.$route.params, packageId },
      });
    },
  },
};
</script>
